import { render, staticRenderFns } from "./HotelService.vue?vue&type=template&id=3d8141c0&scoped=true"
import script from "./HotelService.vue?vue&type=script&lang=js"
export * from "./HotelService.vue?vue&type=script&lang=js"
import style0 from "./HotelService.vue?vue&type=style&index=0&id=3d8141c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8141c0",
  null
  
)

export default component.exports